import { LogoImage } from 'customizations'
import { User } from 'api'
import { withErrorBoundary, Spinner } from 'shared'
import { SmartButtonStub, SmartButtonLink } from 'ui/smart-buttons'
import { useEffect, useState } from 'react'

const GuestAutoLogin = () => {
  // State
  const [state, setState] = useState({ email: '', password: '' })

  // Consts

  // Hooks
  useEffect(() => {
    if (User.signedIn)
      window.location = '/app'
    if (App.forceGuestMode)
      User.guestExperienceSignIn()
  }, [])

  // Custom Methods
  return <></>

}

export default withErrorBoundary(GuestAutoLogin)
